import React from 'react';
import PropTypes from 'prop-types';
import Heart from 'core/icons/Heart';

import abbreviateNumber from 'core/utils/abbreviateNumber';
import { getColor } from 'core/utils/Styles';

import {
	Likes,
	LikesBtn,
} from './favoriteButtonStyles';

import { ResponsiveCheck } from 'core/providers/Responsive';

function FavoriteButton({ likes, on, onClick }) {
	const fillColor = on ? getColor('cinnabar') : getColor('dustyGray');
	return (
		<ResponsiveCheck>{({ isDesktop }) => (
			<LikesBtn onClick={onClick}>
				<Heart fill={fillColor} width={24} height={24} />
				{isDesktop && likes > 0 && (
					<Likes>{abbreviateNumber(likes)}</Likes>
				)}
			</LikesBtn>
		)}</ResponsiveCheck>
	);
}

FavoriteButton.defaultProps = {
	likes: 0,
};

FavoriteButton.propTypes = {
	likes: PropTypes.number,
	on: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
};

export default FavoriteButton;
